import { LabelHTMLAttributes } from 'react'
import cl from 'classnames'

export const Label = ({
  className,
  ...rest
}: LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label
      className={cl(
        'font-myriad ml-4 text-xs pb-0.5 font-medium lg:text-xs lg:leading-[0.875rem] xl:text-[0.625rem] xl:leading-3 1.5xl:text-xs 1.5xl: 1.5xl:leading-[0.875rem] uppercase tracking-wide',
        className
      )}
      {...rest}
    />
  )
}
